/**
 * useResolvedIssues - recently-resolved print-file issues for the retry panel.
 *
 * Fetches PRINT_FILE_ISSUE rows resolved in the last 24h at the current
 * location so the print team can see which garments they can now reprint.
 * Same query config pattern as useRecentlyPrinted.
 *
 * @param locationId - The location ID to fetch for, or null
 * @returns TanStack Query result with recently resolved print-file issues
 */
import { trpc } from '@/lib/trpc';
import { skipToken } from '@tanstack/react-query';

export function useResolvedIssues(locationId: string | null) {
  return trpc.printStation.getRecentlyResolvedIssues.useQuery(
    locationId ? { locationId } : skipToken,
    {
      staleTime: 15_000,
      refetchInterval: 30_000,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: true,
    }
  );
}
